import { BannerAnnouncement } from '@user/notification/BannerAnnouncement';
import { ViewModelTagController } from './ViewModelTagController';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { WorkspaceEntity } from '@workspace/domain/workspace';
import { useViewModelEditable } from '../../hooks/useViewModelEditable';
import { memo } from 'react';

type Props = {
  workspace: WorkspaceEntity;
  viewModel: ViewModelEntity;
  showBannerAnnouncement: boolean;
};

const HeaderMenuSecondFn: React.FC<Props> = ({ workspace, viewModel, showBannerAnnouncement }: Props) => {
  // ビューモデルに編集権限のあるユーザのみタグを表示
  const { isEditableUser } = useViewModelEditable(workspace, viewModel);

  return (
    <>
      {isEditableUser && <ViewModelTagController viewModel={viewModel} />}
      {showBannerAnnouncement && <BannerAnnouncement />}
    </>
  );
};

const propsAreEqual = (prev: Props, next: Props): boolean => {
  return (
    prev.workspace.isEqual(next.workspace) &&
    prev.viewModel.isEqualExcludingUpdatedAt(next.viewModel) &&
    prev.showBannerAnnouncement === next.showBannerAnnouncement
  );
};

export const HeaderMenuSecond = memo(HeaderMenuSecondFn, propsAreEqual);
